import React from 'react';
import ICONS from './lucideIcons';

/**
 * One Lucide icon, drawn inline in currentColor (BRAND_SPEC §12): sizes 16,
 * 20 and 24 only; stroke 1.75 at 24 px and 2 at 16-20 px. An icon never
 * carries meaning alone: it sits beside a word, or the control around it has
 * an accessible name. Pass `label` only for an icon that stands by itself.
 */
function Icon({ name, size = 20, strokeWidth, label, className = '' }) {
  const shapes = ICONS[name];
  if (!shapes) return null;
  const stroke = strokeWidth || (size >= 24 ? 1.75 : 2);
  return (
    <svg
      className={`apr-icon ${className}`.trim()}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
      focusable="false"
      {...(label ? { role: 'img', 'aria-label': label } : { 'aria-hidden': true })}
    >
      {shapes.map(([Tag, attrs], i) => <Tag key={i} {...attrs} />)}
    </svg>
  );
}

export default Icon;
